import "./base.js";

window.Sparkle ??= {};
window.Sparkle.PageBuilder ??= {};
window.Sparkle.PageBuilder.Modal ??= {};

Sparkle.PageBuilder.Modal.IconEditor = class IconEditor extends Sparkle.PageBuilder.Modal.Base {
  constructor(value, options) {
    super(options);
    this.handleIconSelected = this.handleIconSelected.bind(this);
    this.render = this.render.bind(this);
    this._fetch = this._fetch.bind(this);
    this.renderIcons = this.renderIcons.bind(this);
    this.renderIcon = this.renderIcon.bind(this);
    this.setCurrentIconName = this.setCurrentIconName.bind(this);
    this.getOutput = this.getOutput.bind(this);
    if (options == null) {
      options = {};
    }
    this.setCurrentIconName(value);
    this._fetch();

    this.imagePanel = this.modal.container.find(".image-panel");

    // BEHAVIOUR

    this.imagePanel.on("click", "sp-button", this.handleIconSelected);
  }

  // EVENT LISTENERS

  handleIconSelected(event) {
    const element = $(event.target).closest("sp-button");
    return this.setCurrentIconName(element.data("icon-name"));
  }

  // RENDERING

  render() {
    this.show();
    return this;
  }

  // The public icon index (via the deployment config), not the admin page's
  // default manifest: the picker selects icons for public content, and the
  // admin index resolves shared names to the admin variant.
  _fetch() {
    const promise = $.get("/sp_components/configuration.json")
      .then((config) => {
        this.iconsUrl = config.defaults.SpIcon.iconsUrl;
        return $.get(this.iconsUrl);
      })
      .then((iconsJSON) => this.imagePanel.append(this.renderIcons(iconsJSON)));

    return promise;
  }

  renderIcons(iconsJSON) {
    return Object.keys(iconsJSON ?? {}).map((iconName) => this.renderIcon(iconName));
  }

  renderIcon(iconName) {
    const thumbnail = $("<sp-icon>").attr("name", iconName).attr("icons-url", this.iconsUrl);
    return $("<sp-button stacked='true' variant='text-inline' size='small' block='true'>")
      .data("icon-name", iconName)
      .append(thumbnail, iconName);
  }

  setCurrentIconName(iconName) {
    return (this.currentIconName = iconName);
  }

  getOutput() {
    return this.currentIconName;
  }
};
Sparkle.PageBuilder.Modal.IconEditor.prototype.template = "slideshow-dialog";
Sparkle.PageBuilder.Modal.IconEditor.prototype.title = "Select an Icon";
Sparkle.PageBuilder.Modal.IconEditor.prototype.class = "admin-modal icon-editor-modal";
